export default "__VITE_ASSET__b2f92fe7__"